<form-field [config]="config.avConduction"></form-field>
<form-header [label]="'preanalysisDataSectionPq'"></form-header>
<form-field [config]="config.pqCannotMeasure"></form-field>
<ng-container *ngIf="formModel.pqCannotMeasure === false">
  <form-field [config]="config.pqInterval"></form-field>
  <form-field [config]="config.pqHeartRate"></form-field>
</ng-container>

<ng-container *ngIf="!formModel.pq2NotPresent">
  <form-header [label]="'preanalysisDataSectionAdditionalPq'"></form-header>
  <form-field [config]="config.pqInterval2"></form-field>
  <form-field [config]="config.pqHeartRate2"></form-field>
</ng-container>

<ng-container *ngIf="!formModel.pq3NotPresent">
  <form-header [label]="'preanalysisDataSectionAdditionalPq'"></form-header>
  <form-field [config]="config.pqInterval3"></form-field>
  <form-field [config]="config.pqHeartRate3"></form-field>
</ng-container>

<div class="d-flex justify-content-center align-items-center gap-2 my-2">
  <button
    *ngIf="feature505Released && formModel.pq3NotPresent && !formModel.pqCannotMeasure"
    data-testid="add-additional-pq-interval-button"
    class="btn btn-primary"
    (click)="addAdditionalPqInterval()"
  >
    +
  </button>
  <button
    *ngIf="!formModel.pq2NotPresent"
    data-testid="remove-additional-pq-interval-button"
    class="btn btn-primary"
    (click)="removeAdditionalPqInterval()"
  >
    -
  </button>
</div>

<form-header [label]="'preanalysisDataSectionQt'"></form-header>
<form-field [config]="config.qtCannotMeasure"></form-field>
<ng-container *ngIf="formModel.qtCannotMeasure === false">
  <form-field [config]="config.qtInterval"></form-field>
  <form-field [config]="config.qtHeartRate"></form-field>
</ng-container>

<form-header [label]="'preanalysisDataSectionQrs'"></form-header>
<form-field [config]="config.qrsCannotMeasure"></form-field>
<ng-container *ngIf="formModel.qrsCannotMeasure === false">
  <form-field [config]="config.qrsInterval"></form-field>
  <form-field [config]="config.qrsHeartRate"></form-field>
</ng-container>
